import routineStages from './routineStages';
import createRoutineCreator from './createRoutineCreator';
var createRoutine = createRoutineCreator(routineStages);
export default createRoutine;